export default __webpack_public_path__ + "assets/be4162180cfc090391af6d8a482c6dff.svg";